<template>
  <div
    class="pb_content"
    style="
      background: unset;
      overflow: auto;
      padding: 20px;
      margin: 0;
      box-sizing: border-box;
    "
  >
    <div
      style="
        position: absolute;
        width: 100%;
        top: 0;
        height: 100%;
        overflow: auto;
        left: 50%;
        transform: translateX(-50%);
      "
    >
      <div
        class="pb_content_body"
        style="
          background: #fff;
          padding: 0px 21px;
          box-sizing: border-box;
          border-radius: 5px;
        "
      >
        <div class="pb_head">
          <!-- <span>备注：教师可以根据课程、班级条件筛选学生并查看该学生信息</span> -->
          <span
            v-if="type == '2'"
            @click="
              goTo(
                '/tcStudent?userid=' + userid + '&oid=' + oid + '&org=' + org
              )
            "
            >学生管理</span
          >
          <span
            v-else
            @click="
              goTo(
                '/course?userid=' +
                  userid +
                  '&oid=' +
                  oid +
                  '&org=' +
                  org +
                  '&role=' +
                  role
              )
            "
            >课程管理</span
          >
          <span class="sub_head">评价管理</span>
          <!-- <span
            @click="
              goTo(
                '/worksReport?userid=' + userid + '&oid=' + oid + '&org=' + org
              )
            "
            >数据报告</span
          > -->
        </div>
        <div class="student_head">
          <div class="cutTab" >
            <div @click="cutTabBtn(0)" :class="[ cutTabNum==0 ? 'cutTabTwo':'']">按课程查看</div>
            <div @click="cutTabBtn(1)" :class="[ cutTabNum==1 ? 'cutTabTwo':'']">按学生查看</div>
          </div>
          <div class="student_search" v-if="cutTabNum==0">
            <div>班级筛选</div>
            <el-select v-model="classChoose" @change="search">
              <el-option label="全部" value="">全部</el-option>
              <el-option
                v-for="(c, cIndex) in classJuri"
                :key="cIndex"
                :value="c.id"
                :label="c.name"
              ></el-option>
            </el-select>
            <!-- <div
              style="
                line-height: 35px;
                font-size: 14px;
                min-width: 60px;
                margin-left: 10px;
              "
            >
              目标筛选
            </div> -->
            <!-- <el-select v-model="eChoose" @change="search" clear="mbCss">
              <el-option label="全部" value="">全部</el-option>
              <el-option
                v-for="(e, eIndex) in evaJuri"
                :key="eIndex"
                :value="e.id"
                :label="e.title"
              ></el-option>
            </el-select> -->
            <el-input
              v-model="cn"
              placeholder="筛选课程名称"
              @change="search"
            ></el-input>
          </div>

          <div class="student_search" v-if="cutTabNum==1">
            <div>学生筛选</div>
              <el-select v-model="classChoose" @change="search">
                <el-option label="所有班级" value="">所有班级</el-option>
                <el-option
                  v-for="item in classJuri"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-input
                v-model="cn"
                placeholder="筛选学生名称"
                @change="search"
              ></el-input>
          </div>
          <!-- <div
            style="
              margin-left: 10px;
              cursor: pointer;
              float: right;
              min-width: 100px;
            "
            @click="
              goTo(
                '/studentWorks?userid=' + userid + '&oid=' + oid + '&org=' + org
              )
            "
          >
            学生评价管理
          </div> -->
        </div>
      </div>
      <div class="pb_content_body">
        <div class="student_table">
          <el-table
            ref="table"
            :data="tableData1"
            border
            :height="tableHeight"
            :fit="true"
            v-loading="isLoading"
            style="width: 100%"
            v-show="cutTabNum == 0"
            :header-cell-style="{ background: '#f1f1f1', fontSize: '17px' }"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              prop="title"
              label="课程"
              min-width="30"
              align="center"
            ></el-table-column>
            <el-table-column label="班级" min-width="30" align="center">
              <template slot-scope="scope">
                {{
                  tableData1[scope.$index].classJson.className
                    ? tableData1[scope.$index].classJson.className
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="uname"
              label="创建人"
              min-width="30"
              align="center"
            ></el-table-column>
            <!-- <el-table-column
              prop="evaTitle"
              label="目标名称"
              min-width="30"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.evaTitle ? scope.row.evaTitle : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="time"
              label="时间"
              min-width="20"
              align="center"
            ></el-table-column> -->
              
              <el-table-column align="center" min-width="30" label="操作" >
              <template slot-scope="scope">
                <!-- <el-button
                type="primary"
                size="small"
                @click="
                  goTo(
                    '/worksDetail?cid=' +
                      scope.row.courseId +
                      '&userid=' +
                      userid +
                      '&oid=' +
                      oid
                  )
                "
                >查看学生</el-button>-->
                <!-- <el-button type="primary" size="small" @click="getWorkData(scope.row)">生成报告</el-button> -->
                <el-button
                  type="primary"
                  size="small"
                  @click="getWorkData(scope.row)"
                  >查看作业</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  @click="getStudnet(scope.row)"
                  >查看报告</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-if="cutTabNum == 1"
            ref="table"
            :data="tableData"
            border
            :height="tableHeight"
            :fit="true"
            v-loading="isLoading"
            style="width: 100%"
            :header-cell-style="{ background: '#f1f1f1', fontSize: '17px' }"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              prop="name"
              label="学生名称"
              min-width="30"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="className"
              label="班级"
              min-width="40"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.className ? scope.row.className : "-"
                }}
              </template>
            </el-table-column>
             
            <el-table-column label="操作"  align="center" min-width="30">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="getStuWorkData(scope.row)"
                  >查看课程</el-button
                >
              </template>
            </el-table-column>
          </el-table>
         
        </div>
        <div class="student_page">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="total"
            :current-page.sync="page"
            v-if="page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title="查看报告"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="750px"
      :before-close="handleClose"
      class="dialog_diy"
    >
      <div>
        <div class="a_addBox">
          <WorkDate :dataJson="dataJson"></WorkDate>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>-->
  
    <div class="sdetailBox" v-if="dialogVisibleS">
      <StudentWorksDetail
        :uid="dataJson.userid"
        :username="dataJson.name"
        :ooid="oid"
        :oorg="org"
         @StuCancel="StuCancel"
        :dialogVisibleS.sync="dialogVisibleS"
      ></StudentWorksDetail>
    </div>

    <WorkDate
      :dataJson="dataJson"
      :uid="userid"
      :cid="dataJson.courseId"
      :ooid="oid"
      @cancel="cancel"
      :dialogVisibleBao.sync="dialogVisibleBao"
      :dialogVisible.sync="dialogVisible"
      v-if="dialogVisible"
      class="workdates"
    ></WorkDate>
    
    
   



    <!-- 查看报告弹框新版全屏页面 -->

    <el-dialog
      :visible.sync="signDialog"
      width="500px"
      :before-close="handleClose"
      class="lookWorksDialogCSSExp"
      style="overflow: hidden;"
      :append-to-body="true"
      :fullscreen="true"
    >
        <div slot="title" class="header-title">
          <div style="color: #fff">查看报告</div>
        </div>
        <!-- <div style="display: flex;align-items: center;padding-bottom: 15px;font-size: 14px;color: rgba(0, 0, 0, 0.4);">
          <span @click="pageBack" style="height: 100%;cursor: pointer;">评价管理</span>
          <span style="margin: 0 5px;">
            <i class="el-icon-arrow-right"></i>
          </span>
          <span @click="pageBack" style="height: 100%;cursor: pointer;">查看课程</span>
          <span style="margin: 0 5px;">
            <i class="el-icon-arrow-right"></i>
          </span>
          <div style="font-weight: 600;color: rgba(0, 0, 0, 0.9);">{{ checkCourse.title }}-查看报告</div>
        </div>

        <div class="JsonTit">
          <div style="width:94%;margin: 0 auto;font-size: 26px;color: rgba(0, 0, 0, 0.9);">{{ checkCourse.title }}</div>
          <div class="JsonTitBtn">
            <el-button v-if="checkCourse.state == 5" @click="exportWorkPdf" type="primary" size="small"
              >一键导出</el-button
            >
            <el-button style="margin-left: 20px;" @click="pageBack" type="primary" size="small">返回</el-button>
          </div>
        </div>

        <div class="student_search" style="margin-bottom: 10px;justify-content: space-between;width: 94%;margin:30px auto;">
          <div style="display: flex;justify-content: space-between;">
            <div style="margin-right: 10px;">筛选</div>
            <div>
              <el-select
                class="r_select"
                v-model="uClass"
                placeholder="请选择班级"
                filterable
                @change="searchWork2"
              >
                <el-option label="所有班级" value></el-option>
                <el-option
                  v-for="item in classAarray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <el-select
              class="r_select"
              v-model="uname"
              placeholder="请选择学生"
              @change="searchWork2"
            >
              <el-option label="所有学生" value></el-option>
              <el-option
                v-for="item in userAarray"
                :key="item.userid"
                :label="item.sName"
                :value="item.userid"
              >
              </el-option>
            </el-select>

            <div class="typeCheck">
              <el-switch v-model="typeCheckN"></el-switch
              ><span style="font-size: 14px;">查看所有学生</span>
            </div>
          </div>
        </div>
        <div class="TableCss">
          <el-table
            v-loading="isLoading2"
            ref="multipleTable"
            :data="lookReportTab"
            border
            :fit="true"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            :header-cell-style="{ background: 'rgb(238,238,238)' }"
              @selection-change="handleSelectionChange"
          >
         
            <el-table-column
              prop="sName"
              label="姓名"
              min-width="20"
              align="center"
            ></el-table-column>
            <el-table-column
              label="班级"
              min-width="20"
              show-overflow-tooltip
              align="center"
            >
            <template slot-scope="scope">
              <div class="ellipsis">{{ scope.row.class ? scope.row.class : '-' }}</div>
            </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="20">
              <template  slot-scope="scope">
                <el-button
                  v-if="checkCourse.state == 5"
                  type="primary"
                  size="small"
                  @click="lookPdf(scope.row)"
                  >查看报告</el-button
                >
                <el-button
                  v-else
                  type="primary"
                  size="small"
                  @click="getReport(scope.row)"
                  >查看报告</el-button
                >
                <el-button
                  v-if="checkCourse.state == 5"
                  type="primary"
                  size="small"
                  @click="getPdf"
                  >导出报告</el-button
                >
              </template>
              
            </el-table-column>
          </el-table>
          <div v-if="!typeCheckN" style="display: flex;justify-content: space-between; padding:15px 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="10"
              :total="total2"
              @current-change="handleCurrentChange2"
            ></el-pagination>
            <div style="display: flex;"  class="dialog-footer"> </div>
          </div>
        </div> -->

        <lookReport  :oid="oid" @getReport="getReport"  :key="signDialog" :signDialog.sync="signDialog" :checkCourse="checkCourse"></lookReport>
     
    </el-dialog>



    <div class="report_box" v-if="reportVisible">
      <studentReport
        :checkCourse="checkCourse.courseId"
        :checkStudent="checkStudent"
        @cancelR="cancelR"
        :oid="oid"
      ></studentReport>
    </div>

    <!-- <el-dialog
      :visible.sync="worksDialog"
      :before-close="handleClose"
      class="worksDialogCSSExp"
      style="overflow: hidden;"
      :append-to-body="true"
      :fullscreen="true"
    >
      <div slot="title" class="header-title">
        <div style="color: #fff">{{ this.digNum==2 ?'查看':'导出' }}报告</div>
      </div>
      <exportDataDialog  
        :key="exportW" 
        :digNum="digNum" 
        :oid="oid" 
        :multipleSelection="multipleSelection" 
        :worksDialogCon="worksDialogCon" 
        :worksDialog.sync="worksDialog" 
        :cid="checkCourse.courseId">
      </exportDataDialog>
    </el-dialog> -->
   
  </div>
</template>

<script>
import WorkDate from "./components/workData";
import Report from "./components/report";
import studentReport from "./components/studentReport";
import "../../common/aws-sdk-2.235.1.min.js";
import StudentWorksDetail from "./components/studentWorksDetail.vue";
import exportDataDialog from "./components/exportDataDialog.vue";
import lookReport from './components/lookReport'

export default {
  components: {
    WorkDate,
    Report,
    studentReport,
    StudentWorksDetail,
    exportDataDialog,
    lookReport
  },
  data() {
    return {
      worksDialog:false,
      exportW:0,
      digNum:0,
      digCid:'',
      worksDialogCon:{},  
      tableHeight: "500px",
      isLoading: false,
      formLabelWidth: "100px",
      tableData1: [],
      subject: "",
      sClass: "",
      subjectJuri: [],
      projectJuri: [],
      classJuri: [],
      evaJuri: [],
      grade: [],
      projectchoose: "",
      page: 1,
      total: 0,
      groupA: "0",
      classChoose: "",
      eChoose: "",
      cn: "",
      userid: this.$route.query.userid,
      org: this.$route.query.org,
      role: this.$route.query.role,
      oid: this.$route.query.oid,
      type: this.$route.query.type,
      dialogVisible: false,
      dialogVisibleBao: false,
      dataJson: {},
      signDialog: false,
      isLoading2: false,
      page2: 1,
      total2: 0,
      // 查看报告table数据
      lookReportTab: [],
      checkCourse: "",

      reportVisible: false,
      checkStudent: "",
      userAarray: [],
      classAarray:[],
      uname: "",
      uClass:'',
      cutTabNum:0,
      tableData:[],
      dialogVisibleS:false,
      multipleSelection: [],

      typeCheckN: false
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 200;
      if (this.tableHeight <= 530) {
        this.tableHeight = 530;
      }
      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 200;
        if (self.tableHeight <= 530) {
          self.tableHeight = 530;
        }
      };
    });
  },
  watch: {
    typeCheckN(newValue, oldValue) {
        this.getStudnet()
    },
  },
  methods: {


    handleSelectionChange(val) {
      if (val.length > 1) {
      this.$refs.multipleTable.clearSelection(); //清空列表的选中
      this.$refs.multipleTable.toggleRowSelection(val[val.length-1]); //只显示选中最后一个 这时val还是多选的列表(就是你选中的几个数据)
      } else if (val.length === 1) {
            this.multipleSelection=[]
            this.multipleSelection.push( val[val.length-1]);
      } else {
            this.multipleSelection = []; //this.multipleTable是选中行的最后一条数据
      }
    },
    

    goTo(path) {
      this.$router.push(path);
    },
    // 按学生查看所有学生
    getAllStudent() {
      this.isLoading = true;
      let params = {
        oid: this.oid,
        cn: this.cn,
        cid: this.classChoose,
        userid: this.userid,
        page: this.page,
      };
      this.ajax
        .get(this.$store.state.api + "selectAllStudentTeacher", params)
        .then((res) => {
          this.isLoading = false;
          this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.tableData = res.data[0];
          this.classJuri =  res.data[1];
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    // 切换按学生查看，按课程查看
    cutTabBtn(val){
      this.page = 1
      this.cn=''
      this.classChoose=''
      this.cutTabNum = val;
      if (val == 0) {
        this.getProject()
      }else{
        this.getAllStudent()
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "even_row";
      } else {
        return "";
      }
    },
    handleClose(done) {
      done();
    },
    handleCurrentChange(val) {
      this.page = val;
      if (this.cutTabNum == 0) {
        this.getProject()
      }else{
        this.getAllStudent()
      }
    },
    handleCurrentChange2(val) {
      this.page2 = val;
      this.getStudnet();
    },
    //获取班级列表
    // getClass() {
    //   this.isLoading = true;
    //   let params = {
    //     cu: "",
    //     cn: this.sClass,
    //     page: this.page,
    //   };
    //   this.ajax
    //     .get(this.$store.state.api + "selectClass", params)
    //     .then((res) => {
    //       this.isLoading = false;
    //       this.grade = res.data[0];
    //     })
    //     .catch((err) => {
    //       this.isLoading = false;
    //       console.error(err);
    //     });
    // },



    // 按课程查看所有数据
    getProject() {
      this.isLoading = true;
      let params = {
        uid: this.userid,
        cid: this.classChoose,
        eid: this.eChoose,
        cn: this.cn,
        page: this.page,
      };
      this.ajax
        .get(this.$store.state.api + "getProject1", params)
        .then((res) => {
          this.isLoading = false;
          this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.tableData1 = res.data[0];
          this.classJuri = res.data[2];

          var cJuri = res.data[1];

          for (var j = 0; j < this.tableData1.length; j++) {
            this.tableData1[j].classJson = { className: "" };
            for (var i = 0; i < cJuri.length; i++) {
              if (this.tableData1[j].courseId == cJuri[i].courseId) {
                if (cJuri[i].cName != undefined && cJuri[i].cName != null) {
                  if (this.tableData1[j].classJson.className == "") {
                    this.tableData1[j].classJson.className += cJuri[i].cName;
                  } else {
                    this.tableData1[j].classJson.className +=
                      "," + cJuri[i].cName;
                  }
                }
              }
            }
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    search() {
      this.page = 1;
      // this.getProject();
      if (this.cutTabNum == 0) {
        this.getProject()
      }else{
        this.getAllStudent()
      }
    },
    getWorkData(res) {
      this.dataJson = res;
      this.dialogVisible = true;
    },
    getStuWorkData(row) {
      this.dataJson = row;
      this.dialogVisibleS = true;
    },
    cancel() {
      this.dataJson = "";
      this.dialogVisible = false;
    },
    StuCancel() {
      this.dataJson = [];
      this.dialogVisibleS = false;
    },
    cancelR() {
      this.checkStudent = "";
      this.reportVisible = false;
      // this.signDialog = true;
    },

    // 显示查看报告弹框
    getStudnet(row) {
      
      //获取作业
      this.signDialog = true;
      this.isLoading2 = true;
      this.checkCourse = row ? row : this.checkCourse;

      // this.getCourseDetail();
     
    },
    downloadFile(url){
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
      let url2 = url;
      let _url2 = "";
      if (
        url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
      ) {
        _url2 = url2.split(
          "https://view.officeapps.live.com/op/view.aspx?src="
        )[1];
      } else {
        _url2 = url2;
      }
      let _this = this;

      _this.downLoading = true
      var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
      let name = decodeURIComponent(_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1])
      var params = {
        Bucket: "ccrb",
        Key: name
      };
      s3.getObject(params, function (err, data) {
        _this.downLoading = false
        if (err) console.log(err, err.stack); // an error occurred
        else {
          let url = window.URL.createObjectURL(new Blob([data.Body]));
          let a = document.createElement("a");
          a.name = 'student01-学生成长报告.pdf';
          a.href = url;
          a.download = 'student01-学生成长报告.pdf';
          a.click();
          console.log(data); 
        }          // sxuccessful response

      });
    },
    // 获取查看报告班级
    getCourseDetail() {
      let params = {
        cid: this.checkCourse.courseId,
      };
      this.ajax
        .get(this.$store.state.api + "getCourseReportClassList", params)
        .then((res) => {
          this.classAarray = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 查看报告
    getReport(row) {
      this.checkStudent = row.userid;
      this.reportVisible = true;
      // this.signDialog = false;
    },


    getEva() {
      let params = {
        oid: this.oid,
      };
      this.ajax
        .get(this.$store.state.api + "selectAllEvaluation", params)
        .then((res) => {
          this.evaJuri = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
        // lookPdf(val){
    //   this.worksDialogCon=val
    //   this.worksDialog = true;
    //   this.digNum = 2
    //   this.exportW++
    // },
       // 查看报告筛选班级
    // searchWork2() {
    //   this.page2 = 1
    //   this.getStudnet();
    // },
       // clearSelection() {
    //     this.$refs.multipleTable.clearSelection();
    // },
    // 导出pdf
    // exportPdfSetBtn(){
    //   this.worksDialog = true;
    //   this.digNum = 0
    //   this.exportW++
      
    // },
        // getClass() {
    //   let params = {
    //     oid: this.oid,
    //   };
    //   this.ajax
    //     .get(this.$store.state.api + "selectClassBySchool", params)
    //     .then((res) => {
    //       this.classJuri = res.data[0];
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // },
    // 一键导出pdf
    // exportPdfSetAllBtn(){

    //   this.$confirm("是否导出全部学生报告？批量导出需要等待一会儿哦～ 。", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //   .then(() => {
    //     this.worksDialog = true;
    //     this.digNum = 1
    //     this.exportW++
    //   })
    //   .catch(_ => {
    //     this.$confirm.visible=false
    //   })
     
      
    // },
  },
  created() {
    this.page = 1;

    // this.getClass();
    // this.getAllStudent()
    this.getEva();
    this.getProject();
  },
};
</script>

<style scoped>
.sub_head {
  position: relative;
  margin: 0 10px;
}
.sub_head::after {
  content: "";
  width: 100%;
  background: #5a9cea;
  height: 2px;
  position: absolute;
  left: 0;
  bottom: -12px;
}

.pb_head > span:nth-child(1),
.pb_head > span:nth-child(3) {
  /* font-size: 16px; */
  font-size: 26px;
  cursor: pointer;
  /* color: #ab582f; */
  /* color: #409eff; */
  color: #999;
}
.pb_head > span:nth-child(1):hover,
.pb_head > span:nth-child(3):hover {
  color: #000;
}
.pb_head {
  margin: 0 !important;
  width: 100% !important;
}
.student_page {
  margin-top: 10px;
}
.student_head {
  margin-top: 10px;
  padding-bottom: 15px;
  /* display: flex;
  justify-content: space-between; */
}
.student_search {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.student_search > div:nth-child(1) {
  line-height: 35px;
  font-size: 14px;
  min-width: 60px;
}
.student_search > div:nth-child(4) {
  min-width: 100px;
  margin-left: 10px;
  cursor: pointer;
}
.student_search >>> .el-input__inner {
  width: 190px;
  height: 35px;
  margin-left: 10px;
}
.student_table >>> .el-table--border td {
  border-right: 0px !important;
}

.student_page {
  margin-top: 10px;
}

.student_table >>> .el-table,
.student_table >>> .el-table__body-wrapper {
  height: auto !important;
}

.el-table >>> .even_row {
  background-color: #f1f1f1 !important;
}

.dialog_diy >>> .el-dialog__header {
  padding: 9px 20px 10px;
  background: #32455b !important;
}
.dialog_diy >>> .el-dialog__title {
  color: #fff;
  font-size: 15px;
}
.dialog_diy >>> .el-dialog__headerbtn {
  top: 14px;
}
.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
.check_diy >>> .el-dialog__body {
  padding-bottom: 0;
}
.dialog_diy >>> .el-dialog__body,
.dialog_diy >>> .el-dialog__footer {
  background: #fafafa;
}
.r_diy >>> .el-dialog__footer {
  padding: 0;
}
.a_addBox {
  height: 570px;
  overflow: auto;
}

.workdates {
  height: 100%;
  position: absolute;
  top: 0;
  background: #fff;
  overflow: auto;
  z-index: 1;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px;
  box-sizing: border-box;
}
.cancelbox {
  position: absolute;
  z-index: 2;
  /* left: 50%; */
  right: 0;
  /* width: 95%; */
  transform: translateX(-50%);
  display: flex;
  justify-content: flex-end;
  /* padding: 0 90px 0px 0px; */
  box-sizing: border-box;
}

.report_box {
  height: 100%;
  position: absolute;
  top: 0;
  /* background: #fff; */
  background: rgb(231, 242, 252);
  overflow: auto;
  z-index: 1;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px;
  box-sizing: border-box;
}

.mbCss >>> .el-input__inner {
  margin: 0 !important;
}
.student_search >>> .el-input {
  width: auto !important;
}
.cutTab{
  width: 100%;
  display: flex;
  padding: 15px 0;
  justify-content: flex-start;
  font-size: 14px;
  font-weight: 600;
}
.cutTab > div{
  margin-right: 10px;
  padding-bottom: 5px;
  cursor: pointer;
  position: relative;
}
.cutTabTwo{
  color: #409EFF;
}
.cutTabTwo:after {
    content: '';
    position: absolute;
    bottom: -6px;
    right: 0;
    height: 2px;
    width: 30%;
    background-color: #409EFF;
    left: 50%;
    transform: translateX(-50%);
}

.sdetailBox {
  height: 100%;
  position: absolute;
  top: 0;
  background: #fff;
  overflow: auto;
  z-index: 1;
  width: 100%;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  padding: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.cancelbox {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 7%;
  width: 95%;
  transform: translateX(-50%);
  display: flex;
  justify-content: flex-end;
  padding: 0 90px 0px 0px;
  box-sizing: border-box;
}
.ellipsis{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lookWorksDialogCSSExp >>> .el-dialog__header {
  /* padding: 9px 20px 10px; */
  background: #32455b !important;
  color: #fff;
}

.lookWorksDialogCSSExp >>> .el-dialog__wrapper{
  overflow: hidden !important;
}
.lookWorksDialogCSSExp >>> .el-dialog__body {
  width: 100% !important;
  height: calc(100% - 48px);
  overflow: auto;
  padding: 20px 45px;
  box-sizing: border-box;
}
.lookWorksDialogCSSExp >>> .el-dialog.is-fullscreen {
  overflow: hidden;
}



.worksDialogCSSExp>>> .el-dialog__header {
  /* padding: 9px 20px 10px; */
  background: #32455b !important;
}

.worksDialogCSSExp >>> .el-dialog__wrapper{
  overflow: hidden !important;
}
.worksDialogCSSExp >>> .el-dialog__body {
  width: 100% !important;
  padding: 0 !important;
  height: calc(100% - 48px);
  overflow: auto;
}
.worksDialogCSSExp >>> .el-dialog.is-fullscreen {
  overflow: hidden;
}

/* .TableCss >>> .el-table-column--selection .cell{
  display: none;
}
.TableCs >>>  .el-table--border > th > .cell {
  visibility: hidden;
}
.TableCs >>>  .cell {
  visibility: hidden;
} */
.TableCss {
  width: 94%;
  margin: auto;
}
.TableCss >>> .el-table__header-wrapper .el-table__header .el-checkbox {
  display: none;
}
.JsonTit{
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.JsonTitBtn{
  display: flex;
  align-items: center;
}
.typeCheck {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 10px;
  /* margin-bottom: 20px; */
}
.typeCheck > span {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/works.vue